import Message from '../components/Message';
import Cookies from 'js-cookie/src/js.cookie';

export default (function (w, d) {
    'use strict';

    function LoginController() {
        this.initController();
    }

    LoginController.prototype.initController = function () {
        (function ($) {
            $(function () {
                const $login_form = $('#login_form .sign-btn');

                $login_form.on('click', function (e) {
                    e.preventDefault();

                    $('#login_form .error').remove();
                    const action = $('#login_form').attr('action');
                    const data = $('#login_form').serialize();

                    $.ajax({
                        method: 'post',
                        url: action,
                        data: data,
                        /* beforeSend: function () {
                            console.log('Start...');
                        },*/
                        success: function (response) {
                            if (response.status === 'success') {
                                Cookies.remove('guest_href');

                                if (response.url !== '') {
                                    window.location.href = response.url;
                                } else {
                                    window.location.reload(true);
                                }
                            } else if (response.status === "error") {
                                new Message(response.message, 'error');
                            }
                        },
                        /* complete: function () {
                            console.log('Done...');
                        },*/
                        error: function (data) {
                            console.log('Error login...');
                        }
                    });
                });

                const $reset_form = $("#login_reset_form .reset-btn");

                $reset_form.on('click', function (e) {
                    e.preventDefault();

                    $('#login_reset_form .error').remove();
                    const action = $('#login_reset_form').attr('action');
                    const data = $('#login_reset_form').serialize();

                    $.ajax({
                        method: 'post',
                        url: action,
                        data: data,
                        /* beforeSend: function () {
                            console.log('Start...');
                        },*/
                        success: function (response) {
                            if (response.status === 'success') {
                                $('#login_reset_form .alert').show();
                                $('#login_reset_form .form-box').hide();
                            } else if (response.status === "error") {
                                new Message(response.message, 'error');
                            }
                        },
                        /* complete: function () {
                            console.log('Done...');
                        },*/
                        error: function (data) {
                            console.log('Error login...');
                        }
                    });
                });
            })
        }(jQuery))
    }

    return LoginController;
}(window, document));

